<div class="region-wrap">
    <div class="flex">
        <div class="panel m-r-1">
            <div class="panel-header">
                <h1>Regions Feature</h1>
            </div>

            <mat-radio-group class="custom-edit-item radio-group"
                             [(ngModel)]="multiCities.active" (change)="toggleMultipleCities()">
                <mat-radio-button [value]="true">
                    Turn On
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Turn Off
                </mat-radio-button>
            </mat-radio-group>

        </div>

        <div *ngIf="multiCities.active" class="panel">
            <div class="panel-header">
                <h1>Cities Menu</h1>
            </div>

            <mat-radio-group class="custom-edit-item radio-group"
                             [(ngModel)]="multiCities.cityBlock.active" (change)="toggleCityBlock()">
                <mat-radio-button [value]="true">
                    Show
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Hide
                </mat-radio-button>
            </mat-radio-group>

        </div>
    </div>
    <div *ngIf="multiCities.active" class="flex">
        <div class="panel m-r-1">
            <div class="panel-header">
                <h1>Edit Regions</h1>
            </div>

            <div class="m-t-3">
                <div *ngFor="let region of multiCities.regions; let i = index">
                    <ig-accordion *ngIf="!isEditRegion[i]" id="region" class="region-accordion" icon="edit"
                                  title="{{region.name}}"
                                  (onIconClick)="editRegion(region, i)" (onExpand)="loadCities(region)">
                        <div content>
                            <div feedrow *ngFor="let location of region.cities">
                                <mat-icon (click)="removeCityFromRegion(region, location)" class="red-text">
                                    clear
                                </mat-icon>
                                {{location.cityTitle || location.title}}
                            </div>
                            <div class="flex">
                                <p class="add-new-tab" (click)="addCity(region)">
                                    <mat-icon>add</mat-icon>
                                    Add a city
                                </p>
                                <p class="red-text" (click)="deleteRegion(region)">
                                    <mat-icon>delete</mat-icon>
                                    Delete region
                                </p>
                            </div>
                            <div style="margin-bottom: 4px">Region Url</div>
                            <p>/{{hubName}}/region/{{region.id}}<mat-icon url matTooltip="E.g., htttps://imgoingcalendar.com/{{hubName}}/region/{{region.id}}">error_outline</mat-icon></p>
                        </div>
                    </ig-accordion>
                    <div class="flex" *ngIf="isEditRegion[i]">
                        <ig-field label="Edit Region Name"
                                  [formControl]="form.get('regionName')"
                                  icon="edit"
                                  [(ngModel)]="region.name">
                        </ig-field>
                        <ig-button class="edit-region-name" size="md"
                                   [isAsync]="true" (trigger)="updateRegionName($event, region, i)">save
                        </ig-button>
                        <ig-button class="edit-region-name" size="md" color="cancel"
                                   (trigger)="isEditRegion[i]=false">cancel
                        </ig-button>
                    </div>

                </div>
                <p *ngIf="!isCreatingRegion" class="add-new-tab m-t-3" (click)="addNewRegion()">
                    <mat-icon>add</mat-icon>
                    Add a new region
                </p>
                <ig-spinner *ngIf="isCreatingRegion"></ig-spinner>
            </div>

        </div>

        <div class="panel">
            <div class="panel-header">
                <h1>Edit Cities</h1>
            </div>

            <div class="city-wrap">
                <div>
                    <ig-list>
                        <div header>
                            <ig-list-column-header>
                                <ig-row>
                                    <ig-col [xs]="10" [md]="6">TITLE</ig-col>
                                </ig-row>
                            </ig-list-column-header>
                        </div>
                        <div body *ngIf="isLoadingFeeds"><ig-spinner></ig-spinner></div>
                        <div body *ngIf="!isLoadingFeeds">
                            <ig-list-item *ngFor="let location of hubLocations; let i = index">
                                <div (click)="enterEditCity(location)">
                                    <ig-row class="full-width">
                                        <ig-col [xs]="9" [md]="9">
                                            <div>
                                                {{location.cityTitle}}
                                            </div>
                                        </ig-col>
                                        <ig-col [xs]="9" [md]="3">
                                            <ig-row-action-buttons>
                                                <mat-icon matTooltip="Edit">
                                                    edit
                                                </mat-icon>
                                            </ig-row-action-buttons>
                                        </ig-col>
                                    </ig-row>
                                </div>
                            </ig-list-item>
                            <div *ngIf="!hubLocations||!hubLocations.length" class="empty-list">
                                No Content Here...
                            </div>
<!--                            <div class="tour-mask" *ngIf="isLoading"></div>-->
<!--                            <ig-spinner class="tour-spinner" *ngIf="isLoading"></ig-spinner>-->
                        </div>
                    </ig-list>
                </div>
            </div>

        </div>

    </div>

    <div *ngIf="multiCities.active" class="panel">
        <div class="panel-header">
            <h1>Assign Itineraries to Regions</h1>
        </div>

        <div class="city-wrap">
            <div>
                <ig-list>
                    <div header>
                        <ig-list-column-header>
                            <ig-row>
                                <ig-col [xs]="10" [md]="6">TITLE</ig-col>
                            </ig-row>
                        </ig-list-column-header>
                    </div>
                    <div body>
                        <ig-list-item *ngFor="let tour of multiCities.tours; let i = index">
                            <div (click)="enterAssignTour(tour)">
                                <ig-row class="full-width">
                                    <ig-col [xs]="9" [md]="9">
                                        <div>
                                            {{tour.title}}
                                        </div>
                                    </ig-col>
                                    <ig-col [xs]="9" [md]="3">
                                        <ig-row-action-buttons>
                                            <mat-icon matTooltip="Edit">
                                                edit
                                            </mat-icon>
                                        </ig-row-action-buttons>
                                    </ig-col>
                                </ig-row>
                            </div>
                        </ig-list-item>
                        <div *ngIf="!multiCities.tours||!multiCities.tours.length" class="empty-list">
                            No Content Here...
                        </div>
                    </div>
                </ig-list>
            </div>
        </div>

    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/regions/region.component.html